import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const SharpFullStar: FunctionalComponent<IIconProps> = ({
  width = '16',
  height = '16',
  strokeWidth = 1.6,
  fill = '#FAC627',
  stroke = '#8D6708',
}) => {
  return (
    /*@ts-ignore*/
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" strokeWidth={strokeWidth}>
      <path
        fill={fill}
        stroke={stroke}
        d="M12.2328 18.5589L12.0001 18.4366L11.7674 18.5589L5.61072 21.796L6.78655 14.9398L6.83098 14.6807L6.64276 14.4972L1.66182 9.6416L8.54528 8.64129L8.80542 8.60349L8.92175 8.36776L12.0001 2.12985L15.0784 8.36776L15.1947 8.60349L15.4549 8.64129L22.3383 9.6416L17.3574 14.4972L17.1692 14.6807L17.2136 14.9398L18.3894 21.796L12.2328 18.5589Z"
      />
    </svg>
  );
};

export default SharpFullStar;
